<form *ngIf="businessOpenTimes" [formGroup]="openHoursFormGroup">
  <div formArrayName="openHours">
    <div class="row margin-bottom-40 margin-top-20" [ngClass]="{ 'justify-content-center': showSubTitle }">
      <span [ngClass]="{ 'col-12': showSubTitle }" class="col text-align-center open-hours-title open-hours-title-profile">{{
        'csa.openhours-title' | translate
      }}</span>
      <span *ngIf="showSubTitle" class="col-sm-8 text-align-center open-hours-sub-title">{{ 'csa.openhours-subTitle' | translate }}</span>
    </div>

    <div
      class="temporarily-closed-container"
      style="display: flex"
      [ngClass]="{
        notSelectedOpenDaybg: !currentTempClosedValue,
      }">
      <div class="text-container">
        <span class="temporarily-closed-text">{{ 'csa.temporarily-closed-title' | translate | uppercase }}</span>

        <mat-icon class="temp-closed-info"
          >info
          <span class="tooltip-text">{{ 'csa.temporarily.closed.mouseover' | translate }}</span>
        </mat-icon>
      </div>

      <mat-slide-toggle
        [ngClass]="{ 'active-toggle': currentTempClosedValue }"
        (change)="toggleTempClosed($event)"
        [checked]="currentTempClosedValue">
      </mat-slide-toggle>
    </div>

    <div class="justify-content-center">
      <div *ngFor="let position of openHoursArray.controls; let ph = index" [formGroupName]="ph">
        <div
          style="width: 100%"
          [ngClass]="{
            selectedOpenDay: position.value.isSelected,
            notSelectedOpenDay: !position.value.isSelected,
            selectedOpenDayError: openHoursArray.controls[ph].hasError('openDaysError'),
          }">
          <div class="row day">
            <div class="col-sm-3 self-center day-label">
              <mat-label>
                {{ position.value.name | translate }}
              </mat-label>
            </div>
            <div class="col-sm-3 self-center toggle-select" id="openDay_{{ position.value.name }}">
              <mat-slide-toggle
                [ngClass]="{ 'active-toggle': position?.value?.isSelected }"
                formControlName="isSelected"
                (change)="toggleCheckbox($event, position)"
                [checked]="position.value.isSelected">
                <span class="open-close-label">{{ position.value.isSelected ? ('csa.open' | translate) : ('csa.closed' | translate) }}</span>
              </mat-slide-toggle>
            </div>
            <mat-form-field class="col-sm-2 self-center hour-select first-selector">
              <mat-label class="hour-placeholder">{{ 'csa.from' | translate }}</mat-label>
              <mat-select formControlName="from" (selectionChange)="enableHoursDropdown($event, position, 'to')" [value]="position.value.from">
                <mat-option>{{ translationKeyNone | translate }}</mat-option>
                <mat-option *ngFor="let hour of hours[position.value.name].from" [value]="hour.key"> {{ hour.value }}</mat-option>
              </mat-select>
            </mat-form-field>
            <div class="overlapping-hours" *ngIf="openHoursArray.controls[ph].hasError('fromIsRequired')">
              {{ 'csa.hour-required' | translate }}
            </div>
            <mat-icon class="self-center hour-divider">remove</mat-icon>
            <mat-form-field class="col-sm-2 self-center hour-select">
              <mat-label class="hour-placeholder">{{ 'csa.to' | translate }}</mat-label>
              <mat-select
                formControlName="to"
                (selectionChange)="selectInitialHour($event, position, 'splitedFrom')"
                [value]="position.value.to"
                required>
                <mat-option>{{ translationKeyNone | translate }}</mat-option>
                <mat-option *ngFor="let hour of hours[position.value.name].to" [value]="hour.key"> {{ hour.value }}</mat-option>
              </mat-select>
            </mat-form-field>
            <div
              id="AddHours_{{ position.value.name }}"
              *ngIf="!showSecondPeriod[position.value.name].showSecondTime"
              class="show-add-hours-desktop col-sm-1 cursor-class add-hours-div"
              (click)="position.value.isSelected && showTimePeriod(position)">
              <mat-icon class="add-hours-icon self-center">add_circle</mat-icon>
            </div>
            <div class="overlapping-hours" *ngIf="openHoursArray.controls[ph].hasError('toHourOverlapping')">
              {{ 'csa.overlapping-hours' | translate }}
            </div>
            <div class="overlapping-hours" *ngIf="openHoursArray.controls[ph].hasError('toIsRequired')">
              {{ 'csa.hour-required' | translate }}
            </div>
          </div>

          <div class="row day" *ngIf="showSecondPeriod[position.value.name].showSecondTime">
            <div class="col-sm-6 day-label place-div" style="width: 300px"></div>
            <mat-form-field class="col-sm-2 hour-select">
              <mat-label class="hour-placeholder">{{ 'csa.from' | translate }}</mat-label>
              <mat-select
                formControlName="splitedFrom"
                (selectionChange)="enableHoursDropdown($event, position, 'splitedTo')"
                [value]="position.value.splitedFrom">
                <mat-option>{{ translationKeyNone | translate }}</mat-option>
                <mat-option *ngFor="let hour of hours[position.value.name].splitedFrom" [value]="hour.key"> {{ hour.value }}</mat-option>
              </mat-select>
            </mat-form-field>
            <div class="overlapping-hours" *ngIf="openHoursArray.controls[ph].hasError('splitedFromHourOverlapping')">
              {{ 'csa.overlapping-hours' | translate }}
            </div>
            <div class="overlapping-hours" *ngIf="openHoursArray.controls[ph].hasError('splitedFromIsRequired')">
              {{ 'csa.hour-required' | translate }}
            </div>
            <mat-icon class="self-center hour-divider">remove</mat-icon>
            <mat-form-field class="col-sm-2 hour-select">
              <mat-label class="hour-placeholder">{{ 'csa.to' | translate }}</mat-label>
              <mat-select formControlName="splitedTo" [value]="position.value.splitedTo">
                <mat-option>{{ translationKeyNone | translate }}</mat-option>
                <mat-option *ngFor="let hour of hours[position.value.name].splitedTo" [value]="hour.key"> {{ hour.value }}</mat-option>
              </mat-select>
            </mat-form-field>
            <mat-icon (click)="deleteTimePeriod(position)" class="col-sm-1 delete-hours cursor-class" style="width: 40px"> clear</mat-icon>
            <div class="overlapping-hours" *ngIf="openHoursArray.controls[ph].hasError('splitedToHourOverlapping')">
              {{ 'csa.overlapping-hours' | translate }}
            </div>
            <div class="overlapping-hours" *ngIf="openHoursArray.controls[ph].hasError('splitedToIsRequired')">
              {{ 'csa.hour-required' | translate }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</form>

<form *ngIf="businessSpecialOpenTimes" [formGroup]="specialHoursFormGroup">
  <div formArrayName="specialOpenHours">
    <div class="row" [ngClass]="{ 'justify-content-center': showSubTitle }">
      <span class="col text-align-center open-hours-title open-hours-title-profile special-times-title">
        {{ 'csa.special-open-hours-title' | translate }}
      </span>
    </div>
    <div class="justify-content-center p-2" *ngIf="showInitialSpecialTimes">
      <div *ngFor="let position of specialOpenHoursArray.controls; let ph = index" [formGroupName]="ph">
        <div
          class="w-100 p-2"
          [ngClass]="{
            selectedOpenDay: position.value.isSelected,
            notSelectedOpenDay: !position.value.isSelected,
            selectedOpenDayError: specialOpenHoursArray.controls[ph].hasError('specialOpenDaysError'),
          }">
          <div class="row ml-1">
            <mat-form-field class="col-md-3 self-center date-input">
              <mat-label class="hour-placeholder">{{ 'csa.from' | translate }}</mat-label>
              <input
                matInput
                placeholder="From"
                formControlName="fromDate"
                [value]="position.value.fromDate"
                [min]="currentInitialDate"
                [matMenuTriggerFor]="appMenu" />
              <mat-menu #appMenu="matMenu" class="drop-calendar">
                <div (click)="$event.stopPropagation()">
                  <mat-calendar
                    #calendar
                    (selectedChange)="select($event, calendar, ph, position)"
                    [startAt]="currentInitialDate"
                    [minDate]="currentInitialDate"
                    [dateClass]="isSelected"></mat-calendar>
                </div>
              </mat-menu>
            </mat-form-field>
            <mat-icon class="self-center hour-divider mr-3">remove</mat-icon>
            <mat-form-field class="col-md-3 self-center date-input">
              <mat-label class="hour-placeholder">{{ 'csa.to' | translate }}</mat-label>
              <input matInput placeholder="To" formControlName="toDate" [matMenuTriggerFor]="appMenu" [value]="position.value.toDate" />
            </mat-form-field>
            <div class="self-center toggle-select date-toggle-select">
              <mat-slide-toggle
                [ngClass]="{ 'active-toggle': position?.value?.isSelected }"
                formControlName="isSelected"
                (change)="toggleSpecialDay($event, position, ph)"
                [checked]="position.value.isSelected">
                <span class="open-close-label">{{ position.value.isSelected ? ('csa.open' | translate) : ('csa.closed' | translate) }}</span>
              </mat-slide-toggle>
            </div>
            <mat-icon *ngIf="!position.value.isSelected" (click)="deleteSpecialHourEntry(ph, position)" class="col-sm-2 delete-hours cursor-class">
              clear</mat-icon
            >
          </div>
          <div class="row ml-1">
            <div class="col-sm-5"></div>
            <mat-form-field *ngIf="position.value.isSelected" class="col-sm-2 self-center hour-select first-selector">
              <mat-label class="hour-placeholder">{{ 'csa.from' | translate }}</mat-label>
              <mat-select
                formControlName="from"
                (selectionChange)="enableHoursDropdown($event, position, 'to')"
                [value]="position.value.from"
                required>
                <mat-option>{{ translationKeyNone | translate }}</mat-option>
                <mat-option *ngFor="let hour of specialDaysHours[ph].from" [value]="hour.key"> {{ hour.value }}</mat-option>
              </mat-select>
            </mat-form-field>
            <div class="overlapping-hours" *ngIf="specialOpenHoursArray.controls[ph].hasError('fromIsRequired')">
              {{ 'csa.hour-required' | translate }}
            </div>

            <mat-icon *ngIf="position.value.isSelected" class="self-center hour-divider">remove</mat-icon>
            <mat-form-field *ngIf="position.value.isSelected" class="col-sm-2 self-center hour-select">
              <mat-label class="hour-placeholder">{{ 'csa.to' | translate }}</mat-label>
              <mat-select
                formControlName="to"
                (selectionChange)="selectInitialSpecialHour($event, position, ph, 'splitedFrom')"
                [value]="position.value.to"
                required>
                <mat-option>{{ translationKeyNone | translate }}</mat-option>
                <mat-option *ngFor="let hour of specialDaysHours[ph].to" [value]="hour.key"> {{ hour.value }}</mat-option>
              </mat-select>
            </mat-form-field>
            <mat-icon *ngIf="position.value.isSelected" (click)="deleteSpecialHourEntry(ph, position)" class="delete-hours cursor-class">
              clear</mat-icon
            >
            <div
              *ngIf="position.value.isSelected && !showSecondPeriodSpecialTimes[ph].showSecondTime"
              class="show-add-hours-desktop cursor-class add-hours-div"
              (click)="showSecondPeriodSpecialDates(ph)">
              <mat-icon class="add-hours-icon self-center">add_circle</mat-icon>
            </div>
          </div>

          <div class="overlapping-hours" *ngIf="specialOpenHoursArray.controls[ph].hasError('toHourOverlapping')">
            {{ 'csa.overlapping-hours' | translate }}
          </div>
          <div class="overlapping-hours" *ngIf="specialOpenHoursArray.controls[ph].hasError('toIsRequired')">
            {{ 'csa.hour-required' | translate }}
          </div>

          <div class="row ml-1" *ngIf="showSecondPeriodSpecialTimes[ph].showSecondTime">
            <div class="col-sm-5"></div>
            <mat-form-field class="col-sm-2 self-center hour-select first-selector">
              <mat-label class="hour-placeholder">{{ 'csa.from' | translate }}</mat-label>
              <mat-select
                formControlName="splitedFrom"
                (selectionChange)="enableHoursDropdown($event, position, 'splitedTo')"
                [value]="position.value.splitedFrom">
                <mat-option>{{ translationKeyNone | translate }}</mat-option>
                <mat-option *ngFor="let hour of specialDaysHours[ph].splitedFrom" [value]="hour.key"> {{ hour.value }}</mat-option>
              </mat-select>
            </mat-form-field>
            <div class="overlapping-hours" *ngIf="specialOpenHoursArray.controls[ph].hasError('splitedFromHourOverlapping')">
              {{ 'csa.overlapping-hours' | translate }}
            </div>
            <div class="overlapping-hours" *ngIf="specialOpenHoursArray.controls[ph].hasError('splitedFromIsRequired')">
              {{ 'csa.hour-required' | translate }}
            </div>
            <mat-icon class="self-center hour-divider">remove</mat-icon>
            <mat-form-field class="col-sm-2 self-center hour-select">
              <mat-label class="hour-placeholder">{{ 'csa.to' | translate }}</mat-label>
              <mat-select formControlName="splitedTo" [value]="position.value.splitedTo">
                <mat-option>{{ translationKeyNone | translate }}</mat-option>
                <mat-option *ngFor="let hour of specialDaysHours[ph].splitedTo" [value]="hour.key"> {{ hour.value }}</mat-option>
              </mat-select>
            </mat-form-field>
            <mat-icon (click)="deleteTimePeriodSpecialTimes(ph, position)" class="delete-hours cursor-class"> clear</mat-icon>
            <div class="overlapping-hours" *ngIf="specialOpenHoursArray.controls[ph].hasError('splitedToHourOverlapping')">
              {{ 'csa.overlapping-hours' | translate }}
            </div>
            <div class="overlapping-hours" *ngIf="specialOpenHoursArray.controls[ph].hasError('splitedToIsRequired')">
              {{ 'csa.hour-required' | translate }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</form>
<div class="row cursor-class add-special-date-div add-new-date" *ngIf="!showInitialSpecialTimes" (click)="onClickIntitalSpecialTimes()">
  <mat-icon class="add-hours-icon self-center">add_circle</mat-icon>
  <span class="add-hours-text self-center">{{ 'csa.add-new-special-day' | translate }}</span>
</div>
